import { useQuery } from '@tanstack/react-query';
import { fetchServers } from '../api/admin';

export function ServersPage() {
    const { data, isLoading } = useQuery({
        queryKey: ['servers'],
        queryFn: fetchServers,
    });

    if (isLoading) {
        return <div className="text-center py-8">Loading servers...</div>;
    }

    const servers = data?.servers || [];

    return (
        <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
                Servers
            </h1>

            <div className="bg-white dark:bg-gray-800 rounded-lg shadow">
                <div className="p-4 border-b border-gray-200 dark:border-gray-700">
                    <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
                        Activated Servers
                    </h2>
                </div>
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                        <thead>
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                    Server Name
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                    License Key
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                    Version
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                    Status
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                    Last Heartbeat
                                </th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                            {servers.map((server: any) => (
                                <tr key={server.id}>
                                    <td className="px-6 py-4 text-sm text-gray-900 dark:text-gray-200">
                                        {server.serverName}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-mono text-gray-600 dark:text-gray-400">
                                        {server.licenseKey}
                                    </td>
                                    <td className="px-6 py-4 text-sm text-gray-900 dark:text-gray-200">
                                        {server.version}
                                    </td>
                                    <td className="px-6 py-4">
                                        <span className={`px-2 py-1 text-xs rounded-full ${server.status === 'online'
                                                ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
                                                : 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200'
                                            }`}>
                                            {server.status}
                                        </span>
                                    </td>
                                    <td className="px-6 py-4 text-sm text-gray-900 dark:text-gray-200">
                                        {server.lastHeartbeat ? new Date(server.lastHeartbeat).toLocaleString() : 'Never'}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}